module.exports = __webpack_public_path__ + "static/media/icon_calendar.350f3560.svg";